exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/teach-course.js-WebpackMultiOutput";